import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'
import { Container } from '~/components/ui/Container'
import { NoticeSection } from '~/components/pages/message/NoticeSection'
import { MyImage } from '~/components/ui/MyImage'
import { BannerModule } from '../../business/BannerModule'

import {
  getBannerList_marketingModule_bannerList,
  getCategoryList_marketingModule_categoryList,
  listFlash_articleGraph_listFlash_edges_node,
} from '~/graphqls/types'

const StyledFeatureSection = styled.section`
  padding: 0 0 8px 0;
  .market-inter {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -16px;
    justify-content: space-between;
    .inter-item {
      width: 160px;
      margin: 0 16px 32px;
      border: 1px solid ${props => props.theme.light1};
      border-radius: 76px;
      display: flex;
      align-items: center;
      padding: 10px;
      &-thumb {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        overflow: hidden;
      }
      &-body {
        flex: auto;
        margin-left: 12px;
      }
      &-title {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #141416;
      }
      &-desc {
        font-size: 12px;
        line-height: 20px;
        color: ${props => props.theme.dark4};
      }
    }
  }
`

export const FeatureSection: React.FC<{
  bannerData: getBannerList_marketingModule_bannerList[]
  categoryList: getCategoryList_marketingModule_categoryList[]
  noticeList: listFlash_articleGraph_listFlash_edges_node[]
}> = ({ bannerData, categoryList, noticeList }) => {
  return (
    <StyledFeatureSection>
      <Container>
        {!!bannerData.length && <BannerModule data={bannerData} />}
        {!!noticeList?.length && <NoticeSection noticeList={noticeList} />}
        {!!categoryList.length && (
          <div className="market-inter">
            {categoryList.map(inter => (
              <Link
                key={inter.id}
                href={{
                  pathname: '/market',
                  query: { id: inter.id, type: 'human' },
                }}
              >
                <a className="inter-item">
                  <MyImage
                    tag="v400"
                    lazy={false}
                    className="inter-item-thumb"
                    src={inter.image}
                  />
                  <div className="inter-item-body">
                    <div className="inter-item-title">{inter.name}</div>
                    <div className="inter-item-desc">
                      {inter.itemCount} items
                    </div>
                  </div>
                </a>
              </Link>
            ))}
          </div>
        )}
      </Container>
    </StyledFeatureSection>
  )
}
